var _rect, _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 30,
    height: 30,
    rx: 3,
    stroke: "#636363",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.80205 14.1182L0.410156 18.3912V27.5899C0.410156 29.799 2.20102 31.5899 4.41015 31.5899H27.5896C29.7988 31.5899 31.5896 29.799 31.5896 27.5899V23.8737L28.2113 21.3925C26.7978 20.3543 24.8493 20.4519 23.5466 21.6261C22.1322 22.901 19.9809 22.8934 18.5756 21.6085L10.2906 14.0332C8.72716 12.6037 6.32039 12.641 4.80205 14.1182Z",
    fill: "#636363"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.1541,
    cy: 10.2567,
    r: 3.28205,
    fill: "#636363"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.66792899.svg";
export { ForwardRef as ReactComponent };